import React, { useState, useEffect, useRef } from 'react';
import { notify, datePickerFormat,  getPractice, can_visit, all_insurance_options } from "../../helpers";
import { addRejections, editRejections } from '../../services/rejectionTracker';
import { Drawer } from 'vaul';
import DatePicker from 'react-datepicker';
import Spacing from '../Spacing';
import Select from "react-select";
import { Loader } from 'lucide-react';

const selectStyles = {
  control: (base) => ({
    ...base,
    minHeight: '40px',
    borderColor: 'var(--border)',
    borderRadius: '8px'
  }),
  menu: (base) => ({
    ...base,
    zIndex: 1050,
    marginTop: '0',
    borderRadius: '0 0 3px 3px',
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 1050,
    padding: 0
  }),
};

export default function RejectionAddModal(props) {
  const {    
    reloadData = () =>{},
    reloadOverviewData = () =>{},
    reloadDataFilter = {},
    account_id,
    location_id,
    setFilter = () => {},
    rejectionOpen = {},
    setRejectionOpen = () => {},
    allLocation,
    modalType,
    editValue={},
    previousScrollPosition = 0,
  } = props;

  const [insuranceOptions] = useState(all_insurance_options());
  const dropdownRef = useRef(null);

  const defaultValues = {
    account_id:account_id,
    created_by: getPractice("user_id"),
    location_id: editValue.location_id ? editValue.location_id : location_id,
    billing_id: editValue.billing_id ? editValue.billing_id : "",
    first_name: editValue.first_name ? editValue.first_name : "",
    last_name: editValue.last_name ? editValue.last_name : "",
    dob: editValue.dob ? editValue.dob : "",
    dos: editValue.dos ? editValue.dos : "",
    insurance_name: editValue.insurance_name ? editValue.insurance_name : "",
    insurance_id: editValue.insurance_id ? editValue.insurance_id : "",
    issue: editValue.issue ? editValue.issue : "",
    resubmit_date: editValue.resubmit_date ? editValue.resubmit_date : "",
    before_resub_paid: editValue.before_resub_paid ? editValue.before_resub_paid : "",
    after_resub_paid: editValue.after_resub_paid ? editValue.after_resub_paid : "",
    status: editValue.status ? editValue.status : "",
    note: editValue.note ? editValue.note : "",
  }

  const [formData, setFormData] = useState(defaultValues);
  const [uploadDisabled, setUploadDisabled] = useState(true);
  const [uploadLoader, setUploadLoader] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    setUploadDisabled(false);
  };

  const handleChangeDate = (name, value) => {     
    setFormData({
      ...formData,
      [name]: datePickerFormat(value),
    });  
    setUploadDisabled(false);
  };

  useEffect(() => {
    setFormData({
      ...formData,
      location_id: location_id,
      account_id: account_id,
    })
  }, [location_id, account_id]);

  useEffect(() => {
    if(modalType === 'Edit') {
      setFormData({
        ...formData,
        id: editValue?.id,
      });
    }
  }, [editValue]);

  const handleAddRejection = async (e) => {
    e.preventDefault();
    e.target.disabled = true;
    setUploadDisabled(true);
    setUploadLoader(true);

    try {
      const response = await addRejections(formData);
      
      if (response?.detail) {
        notify('error', response?.detail);
      } else { 
        console.log("🚀 ~ handleAddRejection:", response?.data);
        notify("success", "Rejection Created Successfully.");
        setFormData(defaultValues);
        setFilter(reloadDataFilter);
        reloadData(reloadDataFilter);
        reloadOverviewData();
        handleDrawerClose();
      } 
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 5);
      }
    } finally {
      e.target.disabled = false;   
      setUploadDisabled(false);
      setUploadLoader(false);
    }
  };

  const handleEditRejection = async (e) => {
    e.preventDefault();
    e.target.disabled = true;
    setUploadDisabled(true);
    setUploadLoader(true);

    try {
      const response = await editRejections(formData);
      
      if (response?.detail) {
        notify('error', response?.detail);
      } else { 
        if(response?.data?.success){
          notify("success", response?.data?.success);
          setFormData(defaultValues);
          setFilter(reloadDataFilter);
          reloadData(reloadDataFilter);
          reloadOverviewData();
          handleDrawerClose();
        } else {
          notify("error", response?.data?.error);
        }
      } 
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 5);
      }
    } finally {
      e.target.disabled = false;   
      setUploadDisabled(false);
      setUploadLoader(false);
    }
  };

  const allInsuranceOptions = insuranceOptions?.map((option) => ({
    value: option?.name,
    label: option?.name,
  }));

  const handleInsuranceChange = (selectedOption) => {
    setFormData({ ...formData, insurance_name: selectedOption?.value || "" });
    setUploadDisabled(false);
  };

  const allLocations = allLocation?.map((option) => ({
    value: option?.id,
    label: option?.name,
  }));

  const handleLocationChange = (selectedOption) => {
    setFormData({ ...formData, location_id: selectedOption?.value || "" });
    setUploadDisabled(false);
  };

  const allStatus = [
    { value: "Need clinic’s help", label: "Need clinic’s help" },
    { value: "Pending", label: "Pending" },
    { value: "Again denied", label: "Again denied" },
    { value: "Paid", label: "Paid" },
    { value: "Resubmitted", label: "Resubmitted" },
    { value: "Write off", label: "Write off" },
  ];

  const handleStatusChange = (selectedOption) => {
    setFormData({ ...formData, status: selectedOption?.value || "" });
    setUploadDisabled(false);
  };

  const onSubmitHandler = modalType === 'Edit' ? handleEditRejection : handleAddRejection;

  const handleDrawerClose = () => {
    setRejectionOpen(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={rejectionOpen} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">
              {modalType === 'Add' ? 'Add'
              : modalType === 'Edit' ? 'Overview'
              : 'Copy' } Rejection
            </Drawer.Title>
            <Drawer.Description className="sr-only">
              {modalType === 'Add' ? 'Add'
              : modalType === 'Edit' ? 'Overview'
              : 'Copy' } Rejection of a parient
            </Drawer.Description>
            <div className="docpro_modal_wrap docpro_modal_lg no_padding">
              <div className="docpro_modal">
                {modalType === 'Add' ?
                  <h2 className="docpro_fs_24">Add Rejection</h2>
                : modalType === 'Edit' ?
                  <h2 className="docpro_fs_24">Overview</h2>
                :
                  <h2 className="docpro_fs_24">Copy Rejection</h2>
                }

                <form onSubmit={onSubmitHandler}>
                  <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_3 input">
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Billing ID
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='billing_id' onChange={handleChange} value={formData.billing_id} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Last Name <span className="docpro_red_color">*</span>
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='last_name' required onChange={handleChange} value={formData.last_name} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        First Name <span className="docpro_red_color">*</span>
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='first_name' required onChange={handleChange}  value={formData.first_name} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Preferred Location <span className="docpro_red_color">*</span>
                      </label>
                      <Select
                        name="location_id"
                        options={allLocations}
                        placeholder="Search Location..."
                        isSearchable
                        value={allLocations.find((option) => option?.value === formData.location_id) || null}
                        onChange={handleLocationChange}
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        filterOption={(option, rawInput) => {
                          const words = rawInput.toLowerCase().split(" ");
                          return words.every((word) =>
                            option.label.toLowerCase().includes(word)
                          );
                        }}
                        styles={selectStyles}
                      />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Date of Birth <span className="docpro_red_color">*</span>
                      </label>
                      <DatePicker
                        name='dob'
                        selected={formData.dob}
                        className="size_lg"
                        placeholderText='mm/dd/yyyy'
                        onChange={date => handleChangeDate("dob",date)}
                        required                  
                      />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        DOS <span className="docpro_red_color">*</span>
                      </label>
                      <DatePicker
                        name='dos'
                        selected={formData.dos}
                        className="size_lg"
                        placeholderText='mm/dd/yyyy'
                        onChange={date => handleChangeDate("dos",date)}
                        required                  
                      />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Insurance Name
                      </label>
                      <Select
                        name="insurance_name"
                        options={allInsuranceOptions}
                        placeholder="Search Insurance..."
                        isSearchable
                        value={allInsuranceOptions?.find((option) => option?.value === formData?.insurance_name) || null}
                        onChange={handleInsuranceChange}
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        filterOption={(option, rawInput) => {
                          const words = rawInput.toLowerCase().split(" ");
                          return words.every((word) =>
                            option.label.toLowerCase().includes(word)
                          );
                        }}
                        styles={selectStyles}
                      />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Insurance ID
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='insurance_id' onChange={handleChange} value={formData.insurance_id} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Issues
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='issue' onChange={handleChange} value={formData.issue} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Resubmit Date
                      </label>
                      <DatePicker
                        name='resubmit_date'
                        selected={formData.resubmit_date}
                        className="size_lg"
                        placeholderText='mm/dd/yyyy'
                        onChange={date => handleChangeDate("resubmit_date",date)}
                      />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Before Resub Paid Amount
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='before_resub_paid' onChange={handleChange} value={formData.before_resub_paid} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        After Resub Paid Amount
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='after_resub_paid' onChange={handleChange} value={formData.after_resub_paid} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Status
                      </label>
                      <Select
                        name="status"
                        options={allStatus}
                        placeholder="Search Status..."
                        isSearchable
                        value={allStatus.find((option) => option?.value === formData.status) || null}
                        onChange={handleStatusChange}
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        filterOption={(option, rawInput) => {
                          const words = rawInput.toLowerCase().split(" ");
                          return words.every((word) =>
                            option.label.toLowerCase().includes(word)
                          );
                        }}
                        styles={selectStyles}
                      />
                    </div>
                  </div>
                  <Spacing lg="20" sm="20" />
                  <div>
                    <label className="docpro_fw_500 docpro_primary_color">
                      Resubmission Cause
                    </label>
                    <textarea
                      name="note"
                      className="docpro_form_field size_lg docpro_fs_14"
                      cols="30"
                      rows="5"
                      value={formData.note}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <Spacing lg="32" sm="32" />
                  {(can_visit("rejection_tracker") && can_visit('rejection_tracker_create')) && (
                    <div className="docpro_modal_btns small_buttons docpro_mt_auto">
                      <button
                        className="docpro_bordered_btn docpro_fw_600 size_lg"
                        onClick={() => handleDrawerClose()}
                      >
                        Cancel
                      </button>
                      <button
                        type='submit'
                        className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg"
                        disabled={uploadDisabled ? true : false}
                      >
                        {modalType === 'Edit' ?
                          'Update'
                        :
                          'Save'
                        }
                        {uploadLoader && (
                          <span className="docpro_loading">
                            <Loader width={20} height={20} />
                          </span>
                        )}
                      </button>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
